
import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { InputText } from "primereact/inputtext";
import { Image } from "primereact/image";
import asset1 from '../../../../assets/svg/Asset1.svg'
import uploadForms from '../../../../assets/svg/image2.svg'
import master1 from '../../../../assets/svg/Layer3.svg'
import master2 from '../../../../assets/svg/layer4.svg'
import schoolMaster from '../../../../assets/svg/image47.svg'
import Layout from "../../../../components/common/nav/admin/nav.component";
import { Link } from "react-router-dom";

import uploadHelpDocument from '../../../../assets/svg/image48.svg'
import { ValidateAdminRole } from '../../../../helper/validateRole';
import {  Auth  } from "aws-amplify";
import Login from '../../../../setup/auth/login.component';


export default function Masters() {
    const [search, setSearch] = useState("");
   const [isAuthenticated, userHasAuthenticated] = useState(true);

    const contentData  = [
        {
            id: 0,
            image: asset1,
            title: "Users",
            link: "/admin/setting/masters/users",
        },
        {
            id: 4,
            image: schoolMaster,
            title: "School Master",
            link: "/admin/setting/masters/school",
        },

        {
            id: 2,
            image: master1,
            title: "Employee",
            link: "/admin/setting/masters/employee",
        },
        {
            id: 3,
            image: master1,
            title: "Form Report",
            link: "/admin/setting/masters/formreport",
        },
        {
            id: 5,
            image: master1,
            title: "Time Report",
            link: "/admin/setting/masters/timereport",
        },
        // {
        //     id: 3,
        //     image: master2,
        //     title: "Master 2",
        // },
        // {
        //     id: 1,
        //     image: uploadForms,
        //     title: "Upload Forms",
        // },
        // {
        //     id: 5,
        //     image: uploadHelpDocument,
        //     title: "Upload Help Document",
        // },
    ]
    const handleSearch = e => {
        const searchValue = e.target.value;
        setSearch(searchValue);
    
        const filteredData = contentData.filter(item =>
          item.title.toLowerCase().includes(searchValue.toLowerCase())
        );
    
        const filteredContent = searchValue ? filteredData : contentData;
        setContent(filteredContent);
      };
  
      const [content, setContent] = useState(contentData);


      async function onLoad() {
        try {
           await Auth.currentSession();
           if (!ValidateAdminRole()) { userHasAuthenticated(false); }
        } catch (e) {
           console.log("error-->", e)
           userHasAuthenticated(false);
        }
     }
  
  
     useEffect(() => {
        onLoad()
     }, []);

    return isAuthenticated ?   (
        <div>
            <Layout pageTitle="Admin Profile">
                <div className="grid justify-items-end m-3 p-">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" value={search} onChange={handleSearch}/>
                    </span>
                </div>
                <div className='grid grid-cols-4 gap-4 p-3 masters'>

                {content.length > 0 ? (
            content.map(item => (
              <div key={item.id}>
                <Card className="grid justify-items-center bg-white border text-center">
                  <Image src={item.image} alt="user" />
                  <h2 className="text-[#344054] font-semibold">{item.title}</h2>
                  <div className="xl:pt-[1.042vw]">
                    <Link to={item.link}>
                      <button className="bg-[#113699] mt-2 rounded-md text-[#ffff] xl:pt-[0.521vw] xl:pb-[0.521vw] xl:pl-[0.938vw] xl:pr-[0.938vw]">
                        Manage
                      </button>
                    </Link>
                  </div>
                </Card>
              </div>
            ))
          ) : (
            <div className="flex col-span-4 justify-center items-center mx-auto text-[1rem] w-full">
                <h1 >No data found.</h1>
            </div>
          )}
                </div>
            </Layout>
        </div>
   ) : (
    <Login sessionExpired={1} />
);
}
